import { render } from "./SVGMinus.vue?vue&type=template&id=f5fc3612"
import script from "./SVGMinus.vue?vue&type=script&lang=js"
export * from "./SVGMinus.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__